export default __webpack_public_path__ + "static/media/Web_developer.1ad7726d.svg";